export enum FunctionId {
    TRIZ = 'rd_triz',
    QUICK_RESEARCH = 'rd_research',
    COMPANY_SEARCH = 'rd_insights_company_search',
    COMPETITIVE_LANDSCAPE = 'rd_insights_competitive_landscape',
    DEEP_RESEARCH = 'rd_tech_deep_research',
    TECH_MIND = 'rd_air_find_solution_agent',
    VALIDATION = 'rd_air_ai_agent',
    FMEA = 'rd_fmea',
    PROTECT_SMART_SEARCH = 'rd_protect_smart_search',
    NOVELTY_CHECK = 'rd_novelty_check',
    AI_PATENT_DISCLOSURE = 'rd_ai_patent_disclosure',
    ROADMAP = 'rd_roadmap'
}
